import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// swiper css
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./App.scss";
import "./sass/sass_global.scss";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/home/index";
import Venues from "./pages/venues";
import Events from "./pages/events";
import SignUp from "./pages/sign up";
import Login from "./pages/login";
import SignUpIdentity from "./pages/sign up/sign up identity";
import ForgotPassword from "./pages/forgot password";
import AddEvents from "./pages/events/add events";
import CreateVenue from "./pages/venues/CreateVenue";
import SignleEventDetails from "./pages/events/single event details";
import SignleEventAnalaytics from "./pages/events/single event details/event analaytics";
import SignleEventSurvey from "./pages/events/single event details/event survey";
import SingleEventScanner from "./pages/events/single event details/event scanner";
import EventLayout from "./layouts/EventLayout";
import UserSignUp from "./pages/user sign up";
import { useUser } from "./context/UserContext";
import EventBookingDetails from "./pages/events/event booking details";
import EventBookingConfirmation from "./pages/events/event booking confirmation";
import EventSurvey from "./pages/events/event survey";
import VenueDetail from "./pages/venues/venue details";
import ChangePassword from "./pages/forgot password/change-password";
import Settings from "./pages/settings";
function App() {
  const { isSimpleUser } = useUser();

  return (
    <>
      <Router>
        <Routes>
          <Route index path="/sign-up" element={<SignUp />} />
          <Route path={"/"} element={<MainLayout />}>
            {isSimpleUser ? (
              <>
                <Route path="/events" element={<Events />} />
                <Route path="/events/:id" element={<SignleEventDetails />} />
                <Route
                  path="/events/:id/booking"
                  element={<EventBookingDetails />}
                />
                <Route
                  path="/events/:id/booking-confirmation"
                  element={<EventBookingConfirmation />}
                />
                <Route path="/events/:id/survey" element={<EventSurvey />} />
                <Route path="/settings" element={<Settings />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Home />} />
                <Route path="/venue" element={<Venues />} />
                <Route path="/venue/:id" element={<VenueDetail />} />
                <Route path="/create-venue" element={<CreateVenue />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/events" element={<EventLayout />}>
                  <Route index element={<Events />} />
                  <Route path="/events/add-events" element={<AddEvents />} />
                  <Route
                    path="/events/:id/analaytics"
                    element={<SignleEventAnalaytics />}
                  />
                  <Route
                    path="/events/:id/survey"
                    element={<SignleEventSurvey />}
                  />
                  <Route
                    path="/events/:id/scanner"
                    element={<SingleEventScanner />}
                  />

                  <Route path="/events/:id" element={<SignleEventDetails />} />
                </Route>
              </>
            )}
          </Route>

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/login" element={<Login />} />

          <Route path="/user-sign-up" element={<UserSignUp />} />
          <Route path="/sign-up-identity" element={<SignUpIdentity />} />
          <Route path="*" element={<div>Not Found</div>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
